export enum ContractSearchType {
    INCLUSION = 'INCLUSION',
    LASTASSOCIATE = 'LASTASSOCIATE',
}
